import React from "react";
import LoadingAnimation from "./animations/LoadingAnimation";
import classes from "./AddToCartButton.module.css";

const AddToCartButton = (props) => {
  return (
    <div
      className={`${classes.cartBtn} ${classes.btnBackground} ${
        props.loading
          ? "articleBookingCartButtonClicked"
          : "articleBookingCartButton"
      }`}
      style={{
        pointerEvents: props.disabled ? "none" : "",
        opacity: props.disabled ? 0.3 : "",
      }}
    >
      {props.loading === false ? <p>{props.text}</p> : <LoadingAnimation />}
    </div>
  );
};

export default AddToCartButton;
